import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=d9d2712e&scoped=true&"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterConfirm.vue?vue&type=style&index=0&id=d9d2712e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d2712e",
  null
  
)

export default component.exports